// extracted by mini-css-extract-plugin
export default {"table-container":"MNsfwBIV7yeWlIJSGnrV"};